module.exports = __webpack_public_path__ + "static/img/fgbg1-6.8a024e8.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/fgbg1-6.png
// module id = 184
// module chunks = 0